import type { I18nFn } from 'i18n/types/I18nFn';

import { LocationType } from './locationType';

export const EVENT_LOCATION_TYPE = (i18n: I18nFn) =>
  ({
    // TRANSLATORS: listing location type
    [LocationType.ONSITE]: i18n('In Person'),
    // TRANSLATORS: listing location type
    [LocationType.HYBRID]: i18n('Hybrid'),
    // TRANSLATORS: listing location type
    [LocationType.REMOTE]: i18n('Virtual'),
  }) satisfies Record<LocationType, string>;

export const EVENT_LOCATION_TYPE_CHECKBOX_OPTIONS = (i18n: I18nFn) =>
  Object.entries(EVENT_LOCATION_TYPE(i18n)).map(([key, value]) => ({
    name: key,
    label: value,
  }));
